/**
 * The platform's day boundary is America/Montréal — never the viewer's, and
 * never UTC (§6.4).
 *
 * The backend keys `challenge_entries` on `(user, day)` in Montréal time. A
 * parent logging at 21:00 is already tomorrow in UTC, so
 * `toISOString().slice(0,10)` makes two entries an hour apart look like two
 * days — and the streak that results is wrong in the direction that rewards
 * nobody.
 */
export const PLATFORM_TIMEZONE = 'America/Montreal';
/** `YYYY-MM-DD` in Montréal, matching the API's `CalendarDay`. */
export function dayIn(date = new Date(), timeZone = PLATFORM_TIMEZONE) {
    // `en-CA` formats as YYYY-MM-DD, which is exactly the contract's shape.
    return new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
}
export function isToday(day) {
    return day === dayIn();
}
/**
 * Backfill is bounded to yesterday, server-side. The grid disables what the
 * server would refuse rather than letting a member tap into a 400.
 */
export function isBackfillable(day) {
    const today = dayIn();
    if (day > today)
        return false;
    const yesterday = dayIn(new Date(Date.now() - 24 * 60 * 60 * 1000));
    return day >= yesterday;
}
//# sourceMappingURL=dates.js.map